import { render, staticRenderFns } from "./ChatInfoMoment.vue?vue&type=template&id=901269b2&"
import script from "./ChatInfoMoment.vue?vue&type=script&lang=js&"
export * from "./ChatInfoMoment.vue?vue&type=script&lang=js&"
import style0 from "./ChatInfoMoment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports